export default {"src":"/_next/static/media/logo-youtube.9ce24e07.svg","height":180,"width":256,"blurWidth":0,"blurHeight":0};